<div class="input-icon">
  <input type="text" class="input input__large custom-input" required autocomplete="off" [name]="name"
    [placeholder]="placeholder" [(ngModel)]="value" (blur)="onBlurEvent($event)" [disabled]="readonly"
    (focus)="focusGainedEvent($event)" [id]="name"
    [ngClass]="{'small': small, 'success': success === true, 'fail': fail === true, 'input__blue': blue}"
    [tabindex]="tabindex">
    <div class="loading__icon" *ngIf="showLoading">
      <svg-icon name="loading-spinner"></svg-icon>
    </div>
</div>
